import { type ComponentProps } from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { twMerge } from 'tailwind-merge'
import { Interactive } from '../../interactive'
import type { PartProps } from '../../../lib/part-props'

interface DialogBackdropProps extends PartProps<ComponentProps<typeof BaseDialog.Backdrop>> {
  className?: string
}

export function DialogBackdrop({ className, ...props }: DialogBackdropProps) {
  return (
    <BaseDialog.Backdrop
      className={twMerge(
        'bg-backdrop fixed inset-0 transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
        className,
      )}
      {...props}
    >
      {/* A modal's backdrop must take the click, so an outside press closes the
          dialog instead of reaching the app behind the overlay. */}
      <Interactive />
    </BaseDialog.Backdrop>
  )
}
